import styled, { css } from 'styled-components';

export const Wrraper = styled.div``;

export const ModalContainer = styled.div<{ $active: boolean }>`
  position: fixed;
  inset: 0 0 0 0;
  z-index: -1;
  transition: 0.3s;
  visibility: hidden;
  ${({ $active }) =>
    $active
      ? css`
          z-index: 101;
          visibility: visible;
        `
      : ''};
`;
export const ModalContainerBg = styled.div<{ $active: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 1;
  transition: 0.2s;
  opacity: 0;
  background: rgba(31, 44, 81, 0.65);
  visibility: hidden;

  ${({ $active }) =>
    $active
      ? css`
          visibility: visible;
          opacity: 1;
        `
      : ''};
`;
export const ModalContainerContent = styled.div<{ $width?: string; $active: boolean }>`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, 100vh);
  background: ${({ theme }) => theme.palette.white};
  box-shadow: ${({ theme }) => theme.boxShadow.md};
  border-radius: ${({ theme }) => theme.rounded.x5};
  transition: 0.15s;
  padding: ${({ theme }) => theme.spacing.x6};

  ${({ $width }) =>
    $width
      ? css`
          width: ${$width};
        `
      : ''};
  ${({ $active }) =>
    $active
      ? css`
          transform: translate(-50%, -50%);
        `
      : ''};
  max-height: 90vh;
  overflow: auto;
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    width: 300px !important;
  }
`;
export const ModalContainerHead = styled.div`
  justify-content: flex-end;
`;
export const ModalContainerHeadTitle = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.x3};
`;
